<div class="container vh-100 d-flex align-items-center justify-content-center">
  <div class="row w-100 h-75">
    <div class="col-md-6 d-none d-md-flex flex-column left-panel text-white p-5 rounded-start shadow-lg justify-content-center align-items-center">
      <i class="fas fa-users-cog fa-3x mb-4 fs-1"></i>
      <h1 class="display-5 fw-semibold fs-2 btn-active-text-white">HRConnect</h1>
      <p class="lead mb-4 text-center">Modern Human Resource Management System</p>
    </div>

    <div class="col-md-6 bg-white p-5 rounded-end shadow-lg d-flex align-items-center justify-content-center">
      <div class="w-100" style="max-width: 400px;">
        <div class="text-center mb-4 mt-3">
          <h2 class="fw-bold">Welcome Back</h2>
          <p class="text-muted">Sign in to access your dashboard</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="mb-3">
            <label for="email" class="form-label fw-semibold">Email Id / Employee Code</label>
            <input
              id="email"
              type="text"
              class="form-control"
              formControlName="email"
              placeholder="Enter your email or employee code"
              autocomplete="username"
              [class.is-invalid]="emailInvalid"
              [class.is-valid]="submitted && emailCtrl.valid"
            />

            <div *ngIf="emailInvalid" class="invalid-feedback">
              <div *ngIf="emailCtrl.errors?.['required']">Required.</div>
            </div>
          </div>

          <div class="mb-3">
            <label for="password" class="form-label fw-semibold">Password</label>
            <input
              id="password"
              type="password"
              class="form-control"
              formControlName="password"
              placeholder="Enter your password"
              autocomplete="current-password"
              [class.is-invalid]="passwordInvalid"
              [class.is-valid]="submitted && passwordCtrl.valid"
            />

            <div *ngIf="passwordInvalid" class="invalid-feedback">
              <div *ngIf="passwordCtrl.errors?.['required']">Password is required.</div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary w-100 fw-bold mt-2" [disabled]="loading">
            <span *ngIf="!loading">Sign In</span>
            <span *ngIf="loading">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Authenticating...
            </span>
          </button>
        </form>

        <div
          *ngIf="alertMessage"
          class="alert mt-2"
          [ngClass]="{
            'alert-success': alertType === 'success',
            'alert-danger': alertType === 'danger'
          }"
        >
          {{ alertMessage }}
        </div>
      </div>
    </div>
  </div>
</div>